export const module = {
  info: {
    name: 'testing-history-page',
    caption: 'testing history page',
    viewGroup: 'status-and-report'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Testing History',
    icon: 'el-icon-s-unfold',
    routeName: 'module->testing-history-page->view',
    children: [
      {
        caption: 'Manual',
        icon: 'el-icon-s-unfold',
        routeName: 'module->testing-history-page->manual',
      },/*
      {
        caption: 'Automation',
        icon: 'el-icon-s-unfold',
        routeName: 'module->testing-history-page->automation',
      },
      {
        caption: 'Automation No Action',
        icon: 'el-icon-s-unfold',
        routeName: 'module->testing-history-page->automation_without_action',
      },*/
    ]
  }
}

export default module
